import bindAllMethods from '../../../utils/bindAllMethods';
import {
  GetProviderListParam,
  GetProviderListResponseType,
  IProviderClient
} from '../../../clients/shell/provider';
import { GenerateAuthenticationUrlParams } from './types';
import { SetServiceDependencies } from '../../../infra/startup/types';
import { StateParamHandlerService } from '../../../services/stateParamHandlerService';
import {
  AuthorizationUrlBuilder,
  IAuthorizationUrlBuilder
} from './AuthorizationUrlBuilder';
import BaseLoginService from './BaseLoginService';
import ILoginService from './ILoginService';

class LoginServiceNative extends BaseLoginService implements ILoginService {
  private _providerClient: IProviderClient;
  private _stateParamHandlerService: StateParamHandlerService;

  public setDependencies({
    clients,
    services,
    ...rest
  }: SetServiceDependencies): void {
    super.setDependencies({ clients, services, ...rest });
    const { shell } = clients;
    this._providerClient = shell?.providerClient;
    this._stateParamHandlerService = services.stateParamHandlerService;
    bindAllMethods(this);
  }

  public async getProviderList(
    _?: GetProviderListParam
  ): Promise<GetProviderListResponseType> {
    throw new Error('Method not implemented.');
  }

  public async generateAuthenticationUrl(
    options: GenerateAuthenticationUrlParams
  ): Promise<string> {
    const authorizationUrlBuilder: IAuthorizationUrlBuilder =
      new AuthorizationUrlBuilder(
        options.authorizationUrl,
        this._stateParamHandlerService
      );

    authorizationUrlBuilder
      .withMaxAgeZeroOnLogin()
      .withAuthorizationExtraParams()
      .withState(options.postLoginRedirect, options.language, options.country)
      .withLocale(options.language, options.country);

    return authorizationUrlBuilder.build();
  }
}

export default LoginServiceNative;
